export default {"src":"https://wp-static.smartkarma.com/_next/static/media/x-icon.5e767fe0.svg","height":132,"width":132,"blurWidth":0,"blurHeight":0};